import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=ac60acda&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=ac60acda&prod&lang=scss&scoped=true"
import style1 from "./VerificationCode.vue?vue&type=style&index=1&id=ac60acda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac60acda",
  null
  
)

export default component.exports